import {
  AuthProductsPanel,
  AuthSupportPanel,
} from '@/features/auth/components';
import {
  AUTH_FEATURED_PRODUCTS,
  LIFE_AP_QUOTE_URL,
} from '@/features/auth/constants/auth-landing.constants';
import { getPostAuthRedirectPath } from '@/features/auth/utils/get-post-auth-redirect-path.util';
import { SUPPORT_CONTACTS } from '@/shared/constants';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { authenticationService } from '../services';

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
  loader: async () => {
    try {
      const user = await authenticationService.getCurrentUser();

      if (user && getPostAuthRedirectPath(user.attributes) === '/dashboard') {
        throw redirect({ to: '/dashboard' });
      }
    } catch (error) {
      if (error instanceof Response) throw error;
      return null;
    }
  },
});

function AlbaLogo() {
  return (
    <div className='flex items-center justify-center'>
      <img
        src='/Logo Alba Fundo Branco-01.svg'
        alt='Alba Seguradora'
        className='h-[clamp(96px,10vw,150px)] w-auto'
      />
    </div>
  );
}

function AuthLayout() {
  return (
    <div className='h-dvh overflow-y-auto bg-[linear-gradient(150deg,#2a2253_0%,#26305a_28%,#1b6a5e_62%,#009d4d_100%)] font-[family-name:Montserrat,sans-serif]'>
      <div className='grid min-h-full grid-cols-1 content-start min-[900px]:grid-cols-[1fr_clamp(380px,34vw,520px)] min-[900px]:grid-rows-[auto_1fr]'>
        <AuthProductsPanel
          products={AUTH_FEATURED_PRODUCTS}
          quoteUrl={LIFE_AP_QUOTE_URL}
          quoteLabel='Cotar Vida e AP'
          className='min-[900px]:col-start-1 min-[900px]:row-start-1'
        />

        <main className='m-[clamp(12px,1.5vw,16px)] flex flex-col justify-center rounded-3xl bg-[#fafafa] px-[clamp(24px,3vw,44px)] py-[clamp(28px,3vw,52px)] shadow-[0px_4px_4px_0px_rgba(15,22,30,0.08)] min-[900px]:col-start-2 min-[900px]:row-span-2 min-[900px]:row-start-1'>
          <div className='mx-auto flex w-full max-w-[440px] flex-col items-center gap-[clamp(24px,4vh,40px)]'>
            <AlbaLogo />

            <div className='flex w-full flex-col items-center gap-6'>
              <Outlet />
            </div>
          </div>
        </main>

        <AuthSupportPanel
          contacts={SUPPORT_CONTACTS}
          className='min-[900px]:col-start-1 min-[900px]:row-start-2'
        />
      </div>
    </div>
  );
}
